// JSON-LD for the `rank_creators` surface — creators leaderboard rank
// share for a specific user. Schema-wise it's a Person (the ranked user)
// with the rank expressed as `award`. Mirrors `rank.ts` but uses the
// creators ranks.

import type { ShareSurface } from '@/lib/share/events';

import { resolveCanonicalOrigin } from '../origin';
import { organizationId, websiteId } from './site';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildRankCreatorsJsonLd(
  surface: Extract<ShareSurface, { kind: 'rank_creators' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  const personName = ctx.name ?? 'Morfi creator';
  const personUrl = `${resolveCanonicalOrigin()}/portfolio/${surface.userId}`;
  const awards: string[] = [];
  if (surface.topMarketRank > 0) awards.push(`Rank #${surface.topMarketRank} top market`);
  if (surface.marketsCreatedRank > 0)
    awards.push(`Rank #${surface.marketsCreatedRank} by markets created`);
  if (surface.totalVolumeRank > 0)
    awards.push(`Rank #${surface.totalVolumeRank} by total creator volume`);
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${ctx.pageUrl}#webpage`,
      url: ctx.pageUrl,
      name: ctx.description ?? `${personName} on the Morfi creators leaderboard`,
      primaryImageOfPage: { '@type': 'ImageObject', url: ctx.ogImageUrl },
      isPartOf: { '@id': websiteId() },
      publisher: { '@id': organizationId() },
      mainEntity: {
        '@type': 'Person',
        '@id': `${personUrl}#person`,
        name: personName,
        url: personUrl,
        image: ctx.ogImageUrl,
        ...(awards.length > 0 ? { award: awards } : {}),
      },
    },
  ];
}
